import { EventGroupFormValues } from "@utils/mappers/eventGroupMapper";

export const emptyEventGroup: EventGroupFormValues = {
    title: {},
    events: [],
    subscriptionsCount: 1
};
